import React, { useEffect, useReducer } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Nav, Row } from "react-bootstrap";
import { map, filter, includes, isEmpty } from "lodash";

import "./styles.scss";
import { getFileAttributes } from "../../helpers";

export const FolderTree = ({
  activeFolders,
  setActiveFolders,
  getUserDirectories,
  activeKey,
  setActiveKey,
  setIsAnyFolderPicked,
  initialPath,
}) => {
  const scrollIntoView = id => {
    const element = document.getElementById(id);

    element.scrollIntoView(true);
  };

  // We need to use reducer to manage the state of the tree,
  // to avoid re-rendering and the exhaustive deps error
  const initialState = {
    initialPathLength: initialPath.split("/").length,
  };
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_INITIAL_PATH_LENGTH":
        return {
          ...state,
          initialPathLength: initialPath.split("/").length,
        };

      default:
        return state;
    }
  };
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    dispatch({
      type: "SET_INITIAL_PATH_LENGTH",
    });
  }, []);

  const handleSelect = async eventKey => {
    // On new folder click we need to remove all folders that are not
    // children of clicked folder and are lower in the folder tree
    const filteredActiveFolders = filter(activeFolders, folder => {
      // This check is needed to prevent folders with same or similar names
      // not opening their own child folders
      return (
        includes(getFileAttributes(eventKey).directoryPath, folder.path) &&
        eventKey !== folder.path
      );
    });
    // Fetch picked folder data with eventKey as a basePath prop
    const folderData = await getUserDirectories(eventKey);

    if (folderData && !isEmpty(folderData.dirs)) {
      setActiveFolders([...filteredActiveFolders, folderData]);
      scrollIntoView(`${eventKey}/nav`);
    } else {
      setActiveFolders([...filteredActiveFolders]);
    }

    setActiveKey(eventKey);
    setIsAnyFolderPicked(true);
  };

  return (
    <>
      {map(activeFolders, (activeFolder, folderKey) => {
        return (
          <Row key={folderKey} className="m-0">
            <span className="divider" />
            <Nav
              activeKey={activeKey}
              onSelect={handleSelect}
              className="tab-nav"
              id={`${activeFolder.path}/nav`}
            >
              {map(activeFolder.dirs, (dir, dirKey) => {
                const activeKeyArray =
                  (activeKey && activeKey.split("/")) || [];

                return (
                  <Nav.Item key={dirKey} className="tab-nav-item">
                    <Nav.Link
                      className={classNames(
                        "tab-nav-link",
                        activeKeyArray[folderKey + state.initialPathLength] ===
                          dir.name && "tab-nav-link-opened"
                      )}
                      eventKey={dir.path}
                    >
                      {dir.name}
                    </Nav.Link>
                  </Nav.Item>
                );
              })}
            </Nav>
          </Row>
        );
      })}
    </>
  );
};

FolderTree.defaultProps = {
  activeFolders: [],
};
FolderTree.propTypes = {
  activeFolders: PropTypes.arrayOf(
    PropTypes.shape({
      dirs: PropTypes.array,
      path: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  setActiveFolders: PropTypes.func,
  getUserDirectories: PropTypes.func,
  activeKey: PropTypes.string,
  setActiveKey: PropTypes.func,
  setIsAnyFolderPicked: PropTypes.func,
  initialPath: PropTypes.string,
};

export default FolderTree;
